import MediumMaster from '../../features/masters/MediumMaster'

const MediumPage = () => {
  return <MediumMaster />
}

export default MediumPage